import { Card, Text, Stack, Group, Badge, ScrollArea } from '@mantine/core'
import { IconAlertCircle, IconInfoCircle, IconCircleCheck } from '@tabler/icons-react'
import { useWebSocketStore } from '@/store/websocket'
import { formatDistanceToNow } from 'date-fns'

export function RecentEvents() {
  const messages = useWebSocketStore((state) => state.messages)

  const getEventIcon = (event: string) => {
    if (event.includes('error') || event.includes('failed')) {
      return <IconAlertCircle size={16} />
    }
    if (event.includes('success') || event.includes('created')) {
      return <IconCircleCheck size={16} />
    }
    return <IconInfoCircle size={16} />
  }

  const getEventColor = (event: string) => {
    if (event.includes('error') || event.includes('failed')) {
      return 'red'
    }
    if (event.includes('success') || event.includes('created')) {
      return 'green'
    }
    return 'blue'
  }

  // Real convergence events from the WebSocket feed (heartbeats filtered out).
  const events = messages.filter((m) => m.event !== 'heartbeat')

  return (
    <Card shadow="sm" p="lg" radius="md">
      <Text size="lg" fw={600} mb="md">
        Recent Events
      </Text>

      <ScrollArea h={300}>
        {events.length === 0 && (
          <Text size="sm" c="dimmed">
            No recent events yet.
          </Text>
        )}
        <Stack gap="sm">
          {events.slice(-10).reverse().map((event, index) => (
            <Card key={index} p="sm" withBorder>
              <Group justify="space-between" mb="xs">
                <Group gap="xs">
                  {getEventIcon(event.event)}
                  <Badge size="sm" variant="light" color={getEventColor(event.event)}>
                    {event.channel}
                  </Badge>
                </Group>
                <Text size="xs" c="dimmed">
                  {formatDistanceToNow(new Date(event.timestamp), { addSuffix: true })}
                </Text>
              </Group>
              
              <Text size="sm">
                {event.event}
              </Text>
              
              {event.data && (
                <Text size="xs" c="dimmed" mt="xs">
                  {JSON.stringify(event.data, null, 2).substring(0, 100)}...
                </Text>
              )}
            </Card>
          ))}
        </Stack>
      </ScrollArea>
    </Card>
  )
}